module.exports = __webpack_public_path__ + "img/Settings.1893c03.svg";